import React from 'react';
import { useTheme } from '../../hooks/theme';

const Channel = (props) => {
  const theme = useTheme();
  const canais = props.canais;
  const imageDefault = 'https://www.claro.com.br/imagem/logo-generico-atual-claro-1509143658356.png';

  return (
    <div className="mdn-Accordion-content">
      {Object.keys(canais).map((id) => (
        <div key={id} className={`canal ${theme === 'contrast' ? 'contrast' : ''}`}>
          <div className="logo">
            <img
              src={canais[id].imagem !== undefined ? `https://mondrian.claro.com.br/${canais[id].imagem}`.trim().toLowerCase()  : imageDefault}
              alt={canais[id].nome}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://www.claro.com.br/imagem/logo-generico-atual-claro-1509143658356.png';
              }}
            />
          </div>
          <div className="mdn-Text mdn-Text--body nome">{canais[id].nome}</div>
        </div>
      ))}
    </div>
  );
};

export default Channel;
